module.exports = __webpack_public_path__ + "static/media/t-8-q-6.5a8f5381.jpg";